module.exports = __webpack_public_path__ + "static/img/3.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/3.png
// module id = +jPQ
// module chunks = 0